import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useContext } from 'react';
import Icon from '../../UIKit1/icon';
import { WidthContext } from '../../../context';
import { buttonShouldFitContainer } from '../../UIKit1/button/breakpoints';
export var AkButton = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button/loading-button' */
  '@atlaskit/button/loading-button');
});

// 'Native' can't be removed from the name as this hook is exported for products to use
export function useNativeButton(_ref) {
  var forgeDoc = _ref.forgeDoc;
  var _ref2 = forgeDoc.props,
    _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance,
    disabled = _ref2.disabled,
    onClick = _ref2.onClick,
    icon = _ref2.icon,
    _ref2$iconPosition = _ref2.iconPosition,
    iconPosition = _ref2$iconPosition === void 0 ? 'before' : _ref2$iconPosition;
  var buttonText = '';

  // These conditions only allows string children to be passed through.
  // Other elements are not permitted.
  if (typeof forgeDoc.children === 'string') {
    buttonText = forgeDoc.children;
  } else if (Array.isArray(forgeDoc.children) && forgeDoc.children.length && forgeDoc.children[0].type === 'String') {
    var _forgeDoc$children$0$;
    buttonText = (_forgeDoc$children$0$ = forgeDoc.children[0].props) === null || _forgeDoc$children$0$ === void 0 ? void 0 : _forgeDoc$children$0$.text;
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return onClick();
          case 4:
            _context.prev = 4;
            setLoading(false);
            return _context.finish(4);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 4, 7]]);
    }));
    return function handleClick() {
      return _ref3.apply(this, arguments);
    };
  }();
  var iconDom = icon ? /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    glyph: icon
  }) : undefined;
  var iconBefore = iconPosition === 'before' ? iconDom : undefined;
  var iconAfter = iconPosition === 'after' ? iconDom : undefined;
  var width = useContext(WidthContext);
  var shouldFitContainer = buttonShouldFitContainer(width);
  return {
    akButtonProps: {
      shouldFitContainer: shouldFitContainer,
      iconBefore: iconBefore,
      iconAfter: iconAfter,
      isLoading: loading,
      isDisabled: disabled,
      appearance: appearance,
      onClick: handleClick,
      children: buttonText
    }
  };
}
export function Button(props) {
  var _useNativeButton = useNativeButton(props),
    akButtonProps = _useNativeButton.akButtonProps;
  var shouldFitContainer = akButtonProps.shouldFitContainer,
    iconBefore = akButtonProps.iconBefore,
    iconAfter = akButtonProps.iconAfter,
    isLoading = akButtonProps.isLoading,
    isDisabled = akButtonProps.isDisabled,
    appearance = akButtonProps.appearance,
    onClick = akButtonProps.onClick,
    children = akButtonProps.children;
  return /*#__PURE__*/React.createElement(AkButton, {
    shouldFitContainer: shouldFitContainer,
    iconBefore: iconBefore,
    iconAfter: iconAfter,
    isLoading: isLoading,
    isDisabled: isDisabled,
    appearance: appearance,
    onClick: onClick
  }, children);
}